const fcImageCarousel = document.querySelectorAll(".js-fc-carousel");
const socialCarousel = document.querySelector(".js-social-carousel");
const moreImagesCarousel = document.querySelector(".js-more-images-slider");
// moved heroSlider to main vars as its used elsewhere
// const heroSlider = document.querySelector(".js-hero-slider");

if (typeof fcImageCarousel != "undefined" && fcImageCarousel != null) {
    fcImageCarousel.forEach((carousel) => {
        const flkty = new Flickity(carousel, {
            cellAlign: "center",
            prevNextButtons: false,
            pageDots: true,
            draggable: false,
            imagesLoaded: true,
            setGallerySize: false,
            resize: true
        });

        const fcImageCarouselParent = carousel.parentNode;

        const prevButton = fcImageCarouselParent.querySelector(".js-fc-carousel-prev");
        const nextButton = fcImageCarouselParent.querySelector(".js-fc-carousel-next");

        prevButton.addEventListener("click", (e) => {
            e.preventDefault();
            flkty.previous();
        });

        nextButton.addEventListener("click", (e) => {
            e.preventDefault();
            flkty.next();
        });

        const carouselIndex = fcImageCarouselParent.querySelector(".js-carousel-index");

        function updateStatus() {
            let slideNumber = flkty.selectedIndex + 1;
            carouselIndex.textContent = slideNumber + "/" + flkty.slides.length;
        }

        updateStatus();

        flkty.on("select", updateStatus);

        flkty.on(
            "staticClick",
            function (event, pointer, cellElement, cellIndex) {
                if (!cellElement) {
                    return;
                }
                flkty.selectCell(cellIndex);
            }
        );
    });
}

if (typeof socialCarousel != "undefined" && socialCarousel != null) {
    const flkty = new Flickity(socialCarousel, {
        cellAlign: "left",
        wrapAround: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        loop: false,
        imagesLoaded: true,
        contain: true
    });

    const sliderParent = socialCarousel.parentNode;
    const prevButton = sliderParent.querySelector(".js-socials-prev");
    const nextButton = sliderParent.querySelector(".js-socials-next");

    prevButton.addEventListener("click", (e) => {
        e.preventDefault();
        flkty.previous();
    });

    nextButton.addEventListener("click", (e) => {
        e.preventDefault();
        flkty.next();
    });
}

if (typeof moreImagesCarousel != "undefined" && moreImagesCarousel != null) {
    const flkty = new Flickity(moreImagesCarousel, {
        cellAlign: "left",
        wrapAround: false,
        loop: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        imagesLoaded: true,
        contain: true
    });

    const sliderParent = moreImagesCarousel.parentNode;
    const prevButton = sliderParent.querySelector(".js-more-images-prev");
    const nextButton = sliderParent.querySelector(".js-more-images-next");

    prevButton.addEventListener("click", (e) => {
        e.preventDefault();
        flkty.previous();
    });

    nextButton.addEventListener("click", (e) => {
        e.preventDefault();
        flkty.next();
    });

    flkty.on("staticClick", function (event, pointer, cellElement, cellIndex) {
        if (!cellElement) {
            return;
        }

        //get size of image to pass to photoswipe object
        let size = cellElement.getAttribute("data-size").split("x");

        // Photoswipe functions
        var openPhotoSwipe = function () {
            var pswpElement = document.querySelectorAll(".pswp")[0];

            // build items array
            var items = $.map($(moreImagesCarousel).find("img"), function (el) {
                return {
                    src: el.getAttribute("src"),
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10)
                };
            });

            var options = {
                history: false,
                index: cellIndex,
                preventDragEvent: true
            };

            var gallery = new PhotoSwipe(
                pswpElement,
                PhotoSwipeUI_Default,
                items,
                options
            );
            gallery.init();
        };

        openPhotoSwipe();
    });
}

if (typeof heroSlider != "undefined" && heroSlider != null) {
    const flkty = new Flickity(heroSlider, {
        cellAlign: "center",
        prevNextButtons: false,
        autoPlay: 7000,
        pageDots: false,
        draggable: false,
        imagesLoaded: true,
        setGallerySize: false,
        resize: true,
        wrapAround: true,
        on: {
            ready: function () {
                if (typeof loader != "undefined" && loader != null) {
                    this.pausePlayer();
                } else {
                    this.playPlayer();
                }
            },
            settle: function () {
                // console.log('settled rdy to fire in animation');
                let slideIndex = flkty.selectedIndex + 1;
                // console.log(slideIndex);
                const activeSlide = heroSlider.querySelector(".js-hero-slide.is-selected");
                const activeSlideContent = activeSlide.querySelector(".js-slider-content");
                const activeSlideIndex = activeSlide.querySelector(".js-slider-index");
                activeSlideIndex.textContent = slideIndex;
                activeSlideContent.classList.add("is-active");
            },
            change: function () {
                // console.log('fade out shiz thats there');

                const allSlides = heroSlider.querySelectorAll(".js-hero-slide");

                allSlides.forEach((slide) => {
                    const slideContent = slide.querySelector(".js-slider-content");
                    slideContent.classList.remove("is-active");
                });
            }
        }
    });

    const sliderParent = heroSlider.parentNode;
    const prevButton = sliderParent.querySelectorAll(".js-slider-button-prev");
    const nextButton = sliderParent.querySelectorAll(".js-slider-button-next");

    prevButton.forEach(btn => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            flkty.previous();
            flkty.stopPlayer()
        });
    });

    nextButton.forEach(btn => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            flkty.next();
            flkty.stopPlayer()
        });
    });

    flkty.on("staticClick", function (event, pointer, cellElement, cellIndex) {
        if (!cellElement) {
            return;
        }
        flkty.selectCell(cellIndex);
    });
}
